/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppapproDTO,
  CalculateInstallmentAmountParams,
  CalculateLoanFeesParams,
  GenerateLoanScheduleFromConfigParams,
  HasProductDisbursementFeesParams,
  LoanFeeCalculationDTO,
  LoanScheduleDataDto
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Generate a complete loan repayment schedule based on loan application data
 * @summary Generate loan schedule
 */
export const generateLoanSchedule = (
    appapproDTO: AppapproDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanScheduleDataDto>(
      {url: `/api/loans/schedule/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appapproDTO, signal
    },
      options);
    }
  


export const getGenerateLoanScheduleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoanSchedule>>, TError,{data: AppapproDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateLoanSchedule>>, TError,{data: AppapproDTO}, TContext> => {

const mutationKey = ['generateLoanSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLoanSchedule>>, {data: AppapproDTO}> = (props) => {
          const {data} = props ?? {};

          return  generateLoanSchedule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateLoanScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof generateLoanSchedule>>>
    export type GenerateLoanScheduleMutationBody = AppapproDTO
    export type GenerateLoanScheduleMutationError = unknown

    /**
 * @summary Generate loan schedule
 */
export const useGenerateLoanSchedule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoanSchedule>>, TError,{data: AppapproDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateLoanSchedule>>,
        TError,
        {data: AppapproDTO},
        TContext
      > => {

      const mutationOptions = getGenerateLoanScheduleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Check if a loan product has fees that are collected at disbursement time
 * @summary Check for disbursement fees
 */
export const hasProductDisbursementFees = (
    params: HasProductDisbursementFeesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/loans/schedule/has-disbursement-fees`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getHasProductDisbursementFeesInfiniteQueryKey = (params?: HasProductDisbursementFeesParams,) => {
    return [
    'infinite', `/api/loans/schedule/has-disbursement-fees`, ...(params ? [params]: [])
    ] as const;
    }

export const getHasProductDisbursementFeesQueryKey = (params?: HasProductDisbursementFeesParams,) => {
    return [
    `/api/loans/schedule/has-disbursement-fees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getHasProductDisbursementFeesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hasProductDisbursementFees>>>, TError = unknown>(params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasProductDisbursementFeesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasProductDisbursementFees>>> = ({ signal }) => hasProductDisbursementFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasProductDisbursementFeesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hasProductDisbursementFees>>>
export type HasProductDisbursementFeesInfiniteQueryError = unknown


export function useHasProductDisbursementFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasProductDisbursementFees>>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasProductDisbursementFees>>,
          TError,
          Awaited<ReturnType<typeof hasProductDisbursementFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasProductDisbursementFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasProductDisbursementFees>>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasProductDisbursementFees>>,
          TError,
          Awaited<ReturnType<typeof hasProductDisbursementFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasProductDisbursementFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasProductDisbursementFees>>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Check for disbursement fees
 */

export function useHasProductDisbursementFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hasProductDisbursementFees>>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasProductDisbursementFeesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getHasProductDisbursementFeesQueryOptions = <TData = Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError = unknown>(params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasProductDisbursementFeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasProductDisbursementFees>>> = ({ signal }) => hasProductDisbursementFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasProductDisbursementFeesQueryResult = NonNullable<Awaited<ReturnType<typeof hasProductDisbursementFees>>>
export type HasProductDisbursementFeesQueryError = unknown


export function useHasProductDisbursementFees<TData = Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasProductDisbursementFees>>,
          TError,
          Awaited<ReturnType<typeof hasProductDisbursementFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasProductDisbursementFees<TData = Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasProductDisbursementFees>>,
          TError,
          Awaited<ReturnType<typeof hasProductDisbursementFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasProductDisbursementFees<TData = Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Check for disbursement fees
 */

export function useHasProductDisbursementFees<TData = Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError = unknown>(
 params: HasProductDisbursementFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasProductDisbursementFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasProductDisbursementFeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Generate a loan schedule using configuration from the database instead of frontend values
 * @summary Generate loan schedule from product config
 */
export const generateLoanScheduleFromConfig = (
    params: GenerateLoanScheduleFromConfigParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanScheduleDataDto>(
      {url: `/api/loans/schedule/from-config`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGenerateLoanScheduleFromConfigInfiniteQueryKey = (params?: GenerateLoanScheduleFromConfigParams,) => {
    return [
    'infinite', `/api/loans/schedule/from-config`, ...(params ? [params]: [])
    ] as const;
    }

export const getGenerateLoanScheduleFromConfigQueryKey = (params?: GenerateLoanScheduleFromConfigParams,) => {
    return [
    `/api/loans/schedule/from-config`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGenerateLoanScheduleFromConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>>, TError = unknown>(params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenerateLoanScheduleFromConfigInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>> = ({ signal }) => generateLoanScheduleFromConfig(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GenerateLoanScheduleFromConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>>
export type GenerateLoanScheduleFromConfigInfiniteQueryError = unknown


export function useGenerateLoanScheduleFromConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>,
          TError,
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGenerateLoanScheduleFromConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>,
          TError,
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGenerateLoanScheduleFromConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Generate loan schedule from product config
 */

export function useGenerateLoanScheduleFromConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGenerateLoanScheduleFromConfigInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGenerateLoanScheduleFromConfigQueryOptions = <TData = Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError = unknown>(params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGenerateLoanScheduleFromConfigQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>> = ({ signal }) => generateLoanScheduleFromConfig(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GenerateLoanScheduleFromConfigQueryResult = NonNullable<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>>
export type GenerateLoanScheduleFromConfigQueryError = unknown


export function useGenerateLoanScheduleFromConfig<TData = Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>,
          TError,
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGenerateLoanScheduleFromConfig<TData = Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>,
          TError,
          Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGenerateLoanScheduleFromConfig<TData = Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Generate loan schedule from product config
 */

export function useGenerateLoanScheduleFromConfig<TData = Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError = unknown>(
 params: GenerateLoanScheduleFromConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof generateLoanScheduleFromConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGenerateLoanScheduleFromConfigQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calculates the installment amount for a loan based on provided parameters
 * @summary Calculate installment amount
 */
export const calculateInstallmentAmount = (
    params: CalculateInstallmentAmountParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/loans/schedule/calculate-installment`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCalculateInstallmentAmountInfiniteQueryKey = (params?: CalculateInstallmentAmountParams,) => {
    return [
    'infinite', `/api/loans/schedule/calculate-installment`, ...(params ? [params]: [])
    ] as const;
    }

export const getCalculateInstallmentAmountQueryKey = (params?: CalculateInstallmentAmountParams,) => {
    return [
    `/api/loans/schedule/calculate-installment`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCalculateInstallmentAmountInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof calculateInstallmentAmount>>>, TError = unknown>(params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateInstallmentAmountInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateInstallmentAmount>>> = ({ signal }) => calculateInstallmentAmount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CalculateInstallmentAmountInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof calculateInstallmentAmount>>>
export type CalculateInstallmentAmountInfiniteQueryError = unknown


export function useCalculateInstallmentAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateInstallmentAmount>>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateInstallmentAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateInstallmentAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateInstallmentAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateInstallmentAmount>>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateInstallmentAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateInstallmentAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateInstallmentAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateInstallmentAmount>>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Calculate installment amount
 */

export function useCalculateInstallmentAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateInstallmentAmount>>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCalculateInstallmentAmountInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCalculateInstallmentAmountQueryOptions = <TData = Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError = unknown>(params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateInstallmentAmountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateInstallmentAmount>>> = ({ signal }) => calculateInstallmentAmount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CalculateInstallmentAmountQueryResult = NonNullable<Awaited<ReturnType<typeof calculateInstallmentAmount>>>
export type CalculateInstallmentAmountQueryError = unknown


export function useCalculateInstallmentAmount<TData = Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateInstallmentAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateInstallmentAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateInstallmentAmount<TData = Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateInstallmentAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateInstallmentAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateInstallmentAmount<TData = Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Calculate installment amount
 */

export function useCalculateInstallmentAmount<TData = Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError = unknown>(
 params: CalculateInstallmentAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateInstallmentAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCalculateInstallmentAmountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calculate detailed fee breakdown for a loan application including disbursement and repayment fees
 * @summary Calculate loan fees
 */
export const calculateLoanFees = (
    params: CalculateLoanFeesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanFeeCalculationDTO>(
      {url: `/api/loans/schedule/calculate-fees`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCalculateLoanFeesInfiniteQueryKey = (params?: CalculateLoanFeesParams,) => {
    return [
    'infinite', `/api/loans/schedule/calculate-fees`, ...(params ? [params]: [])
    ] as const;
    }

export const getCalculateLoanFeesQueryKey = (params?: CalculateLoanFeesParams,) => {
    return [
    `/api/loans/schedule/calculate-fees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCalculateLoanFeesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanFees>>>, TError = unknown>(params: CalculateLoanFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateLoanFeesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateLoanFees>>> = ({ signal }) => calculateLoanFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CalculateLoanFeesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof calculateLoanFees>>>
export type CalculateLoanFeesInfiniteQueryError = unknown


export function useCalculateLoanFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanFees>>>, TError = unknown>(
 params: CalculateLoanFeesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanFees>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanFees>>>, TError = unknown>(
 params: CalculateLoanFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanFees>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanFees>>>, TError = unknown>(
 params: CalculateLoanFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Calculate loan fees
 */

export function useCalculateLoanFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanFees>>>, TError = unknown>(
 params: CalculateLoanFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCalculateLoanFeesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCalculateLoanFeesQueryOptions = <TData = Awaited<ReturnType<typeof calculateLoanFees>>, TError = unknown>(params: CalculateLoanFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateLoanFeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateLoanFees>>> = ({ signal }) => calculateLoanFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CalculateLoanFeesQueryResult = NonNullable<Awaited<ReturnType<typeof calculateLoanFees>>>
export type CalculateLoanFeesQueryError = unknown


export function useCalculateLoanFees<TData = Awaited<ReturnType<typeof calculateLoanFees>>, TError = unknown>(
 params: CalculateLoanFeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanFees>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanFees<TData = Awaited<ReturnType<typeof calculateLoanFees>>, TError = unknown>(
 params: CalculateLoanFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanFees>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanFees<TData = Awaited<ReturnType<typeof calculateLoanFees>>, TError = unknown>(
 params: CalculateLoanFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Calculate loan fees
 */

export function useCalculateLoanFees<TData = Awaited<ReturnType<typeof calculateLoanFees>>, TError = unknown>(
 params: CalculateLoanFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCalculateLoanFeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




